module.exports = __webpack_public_path__ + "static/media/helically_formed_service_dead_end.f7d5236a.webp";